import { selectUnreadCount } from '@/modules/notifications'
import { useAppSelector } from '@/store/hooks'
import { cn } from 'cn'

/** Unread-notification count for a nav item. Renders nothing at zero. */
export function NavBadge({ className }: { className?: string }) {
  const unread = useAppSelector(selectUnreadCount)
  if (unread === 0) return null
  return (
    <span
      aria-label={`${unread} unread`}
      className={cn('absolute flex h-4 min-w-4 items-center justify-center rounded-full bg-primary px-1 text-[10px] font-semibold text-primary-foreground tabular-nums ring-2 ring-sidebar', className)}
    >
      {unread > 9 ? '9+' : unread}
    </span>
  )
}
